import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Check, X, Trash2, Star, Plus } from "lucide-react";

export default function ReviewsAdmin() {
  const [reviews, setReviews] = useState([]);
  const [filter, setFilter] = useState("");
  const [form, setForm] = useState({ name: "", username: "", comment: "", rating: 5 });
  const [showForm, setShowForm] = useState(false);

  const load = () => { const q = filter ? `?status=${filter}` : ""; api.get(`/admin/reviews${q}`).then((r) => setReviews(r.data)).catch(() => {}); };
  useEffect(() => { load(); }, [filter]); // eslint-disable-line

  const setStatus = async (r, status) => { await api.patch(`/admin/reviews/${r.id}`, { status }); toast.success("Güncellendi"); load(); };
  const del = async (r) => { await api.delete(`/admin/reviews/${r.id}`); toast.success("Silindi"); load(); };
  const add = async (e) => { e.preventDefault(); await api.post("/admin/reviews", form); toast.success("Yorum eklendi"); setForm({ name: "", username: "", comment: "", rating: 5 }); setShowForm(false); load(); };

  const COLORS = { pending: "bg-yellow-500/15 text-yellow-400", approved: "bg-green-500/15 text-green-400", rejected: "bg-red-500/15 text-red-400" };

  return (
    <div>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h1 className="text-2xl font-extrabold text-white">Yorumlar</h1>
        <div className="flex gap-2">
          <select value={filter} onChange={(e) => setFilter(e.target.value)} className="bg-[#171922] border border-white/10 rounded-xl px-4 py-2.5 text-white text-sm">
            <option value="">Tümü</option><option value="pending">Bekleyen</option><option value="approved">Onaylı</option><option value="rejected">Reddedilen</option>
          </select>
          <button onClick={() => setShowForm((s) => !s)} className="btn-gradient px-4 py-2.5 rounded-xl font-bold flex items-center gap-1"><Plus size={16} /> Ekle</button>
        </div>
      </div>
      {showForm && (
        <form onSubmit={add} className="card-surface p-5 mb-6 grid sm:grid-cols-2 gap-3">
          <input required placeholder="İsim" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-[#171922] border border-white/10 rounded-xl px-4 py-2.5 text-white text-sm" />
          <input placeholder="@kullanici" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} className="bg-[#171922] border border-white/10 rounded-xl px-4 py-2.5 text-white text-sm" />
          <textarea required placeholder="Yorum" value={form.comment} onChange={(e) => setForm({ ...form, comment: e.target.value })} className="bg-[#171922] border border-white/10 rounded-xl px-4 py-2.5 text-white text-sm sm:col-span-2" />
          <div className="flex items-center gap-2">{[1, 2, 3, 4, 5].map((i) => <Star key={i} size={20} onClick={() => setForm({ ...form, rating: i })} className={`cursor-pointer ${i <= form.rating ? "text-yellow-400 fill-yellow-400" : "text-gray-600"}`} />)}</div>
          <button className="btn-gradient py-2.5 rounded-xl font-bold">Kaydet</button>
        </form>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {reviews.map((r) => (
          <div key={r.id} className="card-surface p-5" data-testid={`admin-review-${r.id}`}>
            <div className="flex items-center justify-between mb-2">
              <div><div className="font-semibold text-white">{r.name}</div><div className="text-xs text-gray-500">{r.username}</div></div>
              <span className={`px-2 py-1 rounded-full text-xs font-semibold ${COLORS[r.status]}`}>{r.status}</span>
            </div>
            <div className="flex gap-0.5 mb-2">{[1, 2, 3, 4, 5].map((i) => <Star key={i} size={13} className={i <= r.rating ? "text-yellow-400 fill-yellow-400" : "text-gray-600"} />)}</div>
            <p className="text-sm text-gray-300">{r.comment}</p>
            <div className="flex gap-2 mt-4">
              {r.status !== "approved" && <button onClick={() => setStatus(r, "approved")} className="flex-1 py-1.5 rounded-lg bg-green-500/15 text-green-400 text-xs font-semibold flex items-center justify-center gap-1" data-testid={`approve-${r.id}`}><Check size={14} /> Onayla</button>}
              {r.status !== "rejected" && <button onClick={() => setStatus(r, "rejected")} className="flex-1 py-1.5 rounded-lg bg-red-500/15 text-red-400 text-xs font-semibold flex items-center justify-center gap-1"><X size={14} /> Reddet</button>}
              <button onClick={() => del(r)} className="py-1.5 px-3 rounded-lg bg-white/5 text-gray-400"><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
        {reviews.length === 0 && <div className="text-gray-500 col-span-full text-center py-10">Yorum yok</div>}
      </div>
    </div>
  );
}
